let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("QDkFg")).then(() => parcelRequire('3uA7H'));